export const checkPassword = (pass: string) => {
  const exp = /^(?=.*?[A-Za-z0-9#?!@$%^&*-_]).{12,}$/
  return exp.test(pass)
}
